<template>
  <content-view class="orderBigDetail">
    <div class="bg-white pl32 pr32 pt32">
      <div class="orderBigDetail-item pt24 pb16">
        <div class="orderBigDetail-item-title mb24 text-black-85">订单信息</div>
        <div class="form form_3">
          <div class="form-item">
            <div class="form-item-key">订单编号：</div>
            <div class="form-item-val">
              {{ detail.serial }}
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-key">下单时间：</div>
            <div class="form-item-val">
              {{ detail.created_at }}
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-key">分拣中心：</div>
            <div class="form-item-val">
              {{ detail.sorting_name }}
            </div>
          </div>
        </div>
      </div>
      <div class="orderBigDetail-item pt24 pb16">
        <div class="orderBigDetail-item-title mb24 text-black-85">用户信息</div>
        <div class="form form_3">
          <div class="form-item">
            <div class="form-item-key">用户姓名：</div>
            <div class="form-item-val">
              {{ detail.recycling_name }}
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-key">用户电话：</div>
            <div class="form-item-val">
              {{ detail.recycling_phone }}
            </div>
          </div>
        </div>
      </div>
      <div class="orderBigDetail-item pt24 pb16">
        <div class="orderBigDetail-item-title mb24 text-black-85">品类信息</div>
        <div class="form form_3">
          <div class="form-item">
            <div class="form-item-key">品类种类：</div>
            <div class="form-item-val">{{ detail.second_name }}</div>
          </div>
      
          <div class="form-item">
            <div class="form-item-key">品类毛重：</div>
            <div class="form-item-val">{{ detail.total_weight }}公斤</div>
          </div>
          <div class="form-item">
            <div class="form-item-key">品类皮重：</div>
            <div class="form-item-val">{{ detail.actual_weight }}公斤</div>
          </div>
          <div class="form-item">
            <div class="form-item-key">品类净重：</div>
            <div class="form-item-val">{{ detail.weight_amount }}公斤</div>
          </div>
        </div>
      </div>
      <div class="orderBigDetail-item pt24 pb16">
        <div class="orderBigDetail-item-title mb24 text-black-85">称重图片</div>
        <div class="form form_3">
          <div class="form-item">
            <div class="form-item-key">第一次称重：</div>
            <img v-for="(item,index) in detail.first_image" :src="item" :key="index" class="form-item-img" alt="" />
          </div>
          <div class="form-item">
            <div class="form-item-key">第二次称重：</div>
            <img v-for="(item,index) in detail.second_image" :src="item" :key="index" class="form-item-img" alt="" />
          </div>
        </div>
      </div>
      <div class="text-center mt32">
        <a-button type="primary" class="mr8" @click="prev">返 回</a-button>
      </div>
    </div>
  </content-view>
</template>
<script>
export default {
  name: "bigOrderDetail",
  data() {
    return {
      serial: "",
      detail: { first_image: [""], second_image: [""] },
    };
  },
  components: {},
  methods: {
    getDetail() {
      let formData = { serial: this.serial };
      this.$api.account.bigOrderDetail(formData).then((res) => {
        console.log(res);
        if (res.data == null) {
          this.detail = { first_image: [""], second_image: [""] };
        } else {
          this.detail = res.data;
        }
      });
    },
    prev() {
      window.history.go(-1);
    },
  },
  created() {
    this.serial = this.$route.query.serial;
    this.getDetail();
  },
  mounted() {},
};
</script>
<style rel="stylesheet/scss" lang="scss">
.form-item-img{
    width: 200px;
}
.orderBigDetail {
  &-item {
    border-bottom: 1px solid $text-color-black-15;
    &-title {
      color: $title-color-black-85;
      @include pxAndLh(14);
      font-weight: bold;
    }
  }
  .ant-btn-primary {
    width: 81px;
  }
  .fontWeight {
    font-weight: bold;
  }
  .tableImg {
    width: 56px;
    height: 56px;
  }
  .form-item-key {
    min-width: 70px;
  }
  .form-item-val {
    .img {
      width: 160px;
      height: 160px;
      img {
        display: block;
        width: 160px;
        height: 160px;
      }
    }
  }
}
</style>